var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_408_4193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1452 1.61719H3.83186C2.12624 1.61719 0.738525 3.0049 0.738525 4.71053V14.6939C0.738525 16.3963 2.12019 17.7815 3.82088 17.7873V22.3179L10.3312 17.7877H20.1452C21.8508 17.7877 23.2385 16.4 23.2385 14.6939V4.71053C23.2385 3.0049 21.8508 1.61719 20.1452 1.61719ZM17.2164 13.2192H6.76068V11.9008H17.2164V13.2192ZM17.2164 10.4067H6.76068V9.0883H17.2164V10.4067ZM17.2164 7.59416H6.76068V6.2758H17.2164V7.59416Z",
    fill: "#D3B36E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_408_4193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.000244141)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.b06ee3c9472cbff1d0d792990e85f059.svg";
export { ForwardRef as ReactComponent };